import { Create, ListButton, TopToolbar } from 'react-admin';

import ChevronLeft from '@material-ui/icons/ChevronLeft';

import ApplicationSourceForm from './ApplicationSourceForm';

const ApplicationSourceActions = ({ basePath }: any) => (
  <TopToolbar>
    <ListButton
      basePath={basePath}
      label='ra.action.back'
      icon={<ChevronLeft />}
    />
  </TopToolbar>
);

const ApplicationSourceCreate = (props: any) => {
  return (
    <Create actions={<ApplicationSourceActions {...props} />} {...props}>
      <ApplicationSourceForm />
    </Create>
  );
};

export default ApplicationSourceCreate;
